import React from 'react';
import CareMapprIconButton from '../../../Button/CareMapprIconButton';
import { Check, X } from 'react-bootstrap-icons';

interface ActionButtonsProps {
  buttonClassName?: string;
  onConfirm: (e?: React.MouseEvent) => void;
  onCancel: (e?: React.MouseEvent) => void;
}
const EpisodeDetailActionButtons = ({
  onConfirm,
  onCancel,
  buttonClassName,
}: ActionButtonsProps) => {
  return (
    <div className="action-buttons">
      <CareMapprIconButton
        icon={<Check size={20} />}
        onClick={(e) => onConfirm(e)}
        className={`min-width-auto ${buttonClassName}`}
      />
      <CareMapprIconButton
        icon={<X size={20} />}
        onClick={(e) => onCancel(e)}
        className={`min-width-auto ${buttonClassName}`}
      />
    </div>
  );
};

export default EpisodeDetailActionButtons;
